<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteEmployeeConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid || form.edit" :vm-active="isModalEmployeeVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("employees.contact_placeholder")' :danger="$v.form.contact.$invalid && $v.form.contact.$model" :danger-text="'Name must have at least 4 ' + $v.form.contact.$params.minLength + ' letters.'" v-model="form.contact" :label='$t("employees.contact")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("employees.phone_placeholder")' :danger="$v.form.phone.$invalid && $v.form.phone.$model" :danger-text="$t('validation.required', { attribute: $t('employees.phone') })" v-model="form.phone" :label='$t("employees.phone")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("employees.email_placeholder")' :danger="!$v.form.email.email" danger-text="Field is email" v-model="form.email" :label='$t("employees.email")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(type="password" icon='lock-outline' :placeholder='$t("users.password_placeholder")' :danger="$v.form.password.$invalid && typeof $v.form.password.$model !== 'undefined'" :danger-text="$v.form.password.minLength ? $v.form.password.required ? '' : $t('validation.required', { attribute: $t('users.password') }) : $t('validation.min.string', { attribute: $t('users.password'), min: 4 })" :description-text='isAdd ? "" : $t("users.leave_empty")' v-model="form.password" :label='$t("users.password")' required pass)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(type="password" icon='lock-outline' :placeholder='$t("users.confirm_password_placeholder")' :danger="($v.form.confirm_password.$invalid) && (typeof $v.form.confirm_password.$model) !== 'undefined'" :danger-text="$t('validation.same', { attribute: $t('users.confirm_password'), other: $t('users.password') })" v-model="form.confirm_password" :label='$t("users.confirm_password")' required pass)
</template>

<script>
import { required, requiredIf, minLength, email, sameAs } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')
const { mapActions: mapActionsEmployees } = createNamespacedHelpers('Employees')

export default {
  name: 'ModalEmployees',
  props: {
    form: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations () {
    return {
      form: {
        contact: {
          required
        },
        phone: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required: requiredIf((password) => {
            return this.isAdd
          }),
          minLength: minLength(4)
        },
        confirm_password: {
          required: requiredIf((confirmPassword) => {
            return this.form.password
          }),
          sameAsPassword: sameAs('password')
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalEmployeeVisible'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('employees.add') : this.$t('employees.edit_employee')
    }
  },
  methods: {
    ...mapActions([
      'addEmployee',
      'editEmployee',
      'setModalEmployeeVisible'
    ]),
    ...mapActionsEmployees(['loadEmployees']),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      if (this.form.edit) {
        await this.editEmployee({ employee: this.form, file: this.file })
      } else {
        await this.addEmployee({ customer: this.form, file: this.file })
      }
      this.loadEmployees({ page: 1, employer: this.$route.params.customerId })
    },
    async deleteEmployeeConfirm (customer) {},
    close () {
      this.setModalEmployeeVisible(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.separador-modal-btn {
  padding-right: 10px;
}
</style>
